import { createBrowserRouter } from 'react-router-dom';

import { routeConfig } from './routeConfig';

/**
 * The route tree itself lives in `routeConfig.tsx`, kept import-safe under a
 * plain Node test environment (`routeConfig.test.ts`). `createBrowserRouter`
 * reaches for `document`/`window` immediately at call time, so this file —
 * the only one that calls it — is intentionally the one place that isn't
 * unit-testable without a DOM.
 */
export const router = createBrowserRouter(routeConfig);
